export interface Dimension {
  name: string;
  tag_key: string;
  group_by: string;
  ei: boolean;
  ai: boolean;
  updated_by?: string;
  updated_at?: string;
  operation?: string;
}

export interface DimensionMeta {
  name: string;
  tag_key: string;
  backend_name: string;
  group_by: string;
  show_tag_field: boolean;
}

export interface Operation {
  dimension: Dimension;
  dimensionOperation: string;
  product?: string;
}

export interface DimensionPayload {
  configId: number;
  configurationVersion: number;
  dimensions: Dimension[];
  operation?: Operation;
}

export interface MaxInfo {
  activeEIDimension: number;
  activeAIDimension: number;
  maxEIDimension: number;
  maxAIDimension: number;
}

export type OperationType = 'created' | 'deleted' | 'activated' | 'deactivated' | 'name changed';
export const CREATE_OPERATION: OperationType = 'created';
export const ACTIVATE_OPERATION: OperationType = 'activated';
export const DEACTIVATE_OPERATION: OperationType = 'deactivated';
export const DELETE_OPERATION: OperationType = 'deleted';
export const CHANGE_NAME_OPERATION: OperationType = 'name changed';

export interface CreateDimensionType {
  name: string;
  custom_name: string;
  tag_key: string;
  selected_products: string[];
}

export interface SelectItem {
  value: string;
  label: string;
  key: string;
}
